import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { Header } from "../../components/Header";
import Analytics from "../../utils/analytics";
// Language picker hidden for now.
// import LanguageCard from "../../components/Language/LanguageCard";
import NotificationCard from "../../components/Notifications/NotificationCard";
import InstallCard from "../../components/Install/InstallCard";
import { SettingsSection } from "../../components/Settings/settingsUi";
import { C, FONT_BODY, TYPE, topBarOffset } from "../../utils/designTokens";

function Settings() {
  useEffect(() => {
    Analytics.track(Analytics.events.NAVIGATE_TO_PROFILE);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: C.bg }}>
      <Header />
      <Box
        component="main"
        sx={{
          boxSizing: "border-box",
          width: "100%",
          maxWidth: 760 + 64,
          px: { xs: 2, sm: 3, md: 4 },
          pt: { xs: topBarOffset(20), md: topBarOffset(28) },
          pb: 6,
          display: "flex",
          flexDirection: "column",
          gap: "28px",
        }}
      >
        <Box component="header">
          <Box component="h1" sx={{ ...TYPE.pageTitle, fontSize: 34, m: 0, color: C.ink }}>
            Settings
          </Box>
          <Box component="p" sx={{ m: 0, mt: 0.75, fontFamily: FONT_BODY, fontSize: 15, color: C.muted }}>
            Manage how RushMyFood keeps you updated
          </Box>
        </Box>

        <SettingsSection id="settings-notifications" title="Notifications">
          <NotificationCard />
        </SettingsSection>

        <SettingsSection id="settings-app" title="App">
          <InstallCard />
        </SettingsSection>
      </Box>
    </Box>
  );
}

export default Settings;
